import { render, staticRenderFns } from "./ModalNewApp.vue?vue&type=template&id=266806b9&scoped=true&"
import script from "./ModalNewApp.vue?vue&type=script&lang=js&"
export * from "./ModalNewApp.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewApp.vue?vue&type=style&index=0&id=266806b9&scoped=true&lang=scss&"
import style1 from "./ModalNewApp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266806b9",
  null
  
)

export default component.exports